import React from 'react';

function formatActivity(event) {
  switch (event.action) {
    case 'created':
      return 'Project created';
    case 'stage_changed': {
      const to = typeof event.details === 'object' ? event.details?.to : event.details;
      return `Stage changed to ${(to || '').replace(/_/g, ' ')}`;
    }
    case 'updated': {
      const fields = Array.isArray(event.details) ? event.details
        : event.details?.fields || [];
      return `Updated ${fields.join(', ')}`;
    }
    case 'comment': {
      const sec = typeof event.details === 'object' ? event.details?.section : event.details;
      return `Comment added on ${sec || 'project'}`;
    }
    case 'enrichment':
      return 'Automated data refreshed';
    default:
      return event.action;
  }
}

function timeAgo(isoStr) {
  const d = new Date(isoStr);
  const now = new Date();
  const diff = Math.floor((now - d) / 1000);
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return d.toLocaleDateString();
}

export default function ActivityTimeline({ activity = [] }) {
  const sorted = [...activity].reverse();

  if (sorted.length === 0) {
    return <div className="activity-empty">No activity yet</div>;
  }

  return (
    <div className="activity-timeline">
      {sorted.map((event, i) => (
        <div key={i} className="activity-event">
          <div className={`activity-dot activity-dot-${event.action}`} />
          <div className="activity-content">
            <span className="activity-time">{timeAgo(event.timestamp)}</span>
            <span className="activity-user">{event.user}</span>
            <span className="activity-text">{formatActivity(event)}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
